const schema = localStorage.getItem("schema")

export const basicFormData = () => ({
    inputData: {
        role_name:"",
        created_by: "",
        updated_by: "",
        is_active: true,
    },
});

export const createPageData = () => {
    const payload = {
        modelName: "role_masters",
        schema:schema,
        inputData: {
            role_name: "",
            created_by: "",
            updated_by: "",
            is_active: true,
        },
        moduleWhereCondition: {
            is_active: true,
        },
        relations: [
            {
                module: "role_masters",
                moduleAs: "subcontractor",
                isModuleWhereConditionRequired: true,
            },
            {
                module: "role_documents",
                moduleAs: "role_documents",
                isModuleWhereConditionRequired: true,
            },
        ],
    };
    const deleteRelation = [
        {
            modelName: "role_masters",
            moduleAs: "subcontractor",
            foreignKey: "subcontractor_id",
        },
        {
            modelName: "role_documents",
            moduleAs: "role_documents",
            foreignKey: "role_id",
        },
    ];

    const navigatePage = { back: "/role-list" };

    const headerName = "role";

    const validationType = "RoleCreate";
    const createEndpoint = "/updaterelationaldata";
    const updateEndpoint = "/updaterelationaldata";
    const getEndpoint = "/getRecords";
    const roleTypeList = [
        {
            options: [
                { label: "Bermad role", value: 1 },
                { label: "Subcontractor", value: 2 },
                { label: "Customer", value: 3 },
                { label: "Subcontractor sub role", value: 4 },
            ],
        },
    ];
    const dependentDropdownData = [
        {
            module_name: "role_masters",
            initialPayload: { modelName: "role_masters" },
            isOtherDependentOnThis: false,
            patchFieldName: "role_name",
            dropdownDataValue: "role_id",
            endPoint: "/getRecords",
        },
    ];
    const multiModuleFormModules = [
        {
            moduleName: "role_documents",
            formFields: [
                {
                    label: "Document Name",
                    name: "document",
                    type: "text",
                    placeholder: "Document name",
                    asterisk: true,
                },

                {
                    label: "File",
                    name: "file",
                    type: "file",
                    placeholder: "Document",
                },
            ],
        },
        {
            moduleName: "subcontractor",
            formFields: [
                {
                    label: "Role Name",
                    name: "role_name",
                    type: "text",
                    placeholder: "Role name",
                }
            ],
        },
    ];

    const multiModuleNames = multiModuleFormModules.map(
        (module) => module.moduleName
    );

    return {
        payload,
        navigatePage,
        headerName,
        validationType,
        roleTypeList,
        multiModuleNames,
        multiModuleFormModules,
        createEndpoint,
        updateEndpoint,
        getEndpoint,
        dependentDropdownData,
        deleteRelation,
    };
};

export const listPageData = (type) => {
    const payload = {
        modelName: "role_masters",
        schema:schema        
    };

    const columnData = [
        { label: "Sr. No", value: "index" },
        { label: "Role Name", value: "role_name" },
        { label: "Status", value: "is_active" },
        { label: "Action", value: "actions" },
    ];

    const navigatePage = {
        create: "/role-create",
        edit: "/role-create",
        view: "/role-view",
    };

    const searchfields = [
        "role_masters.first_name",
        "role_masters.last_name",
        "role_masters.email_id",
        "role_masters.mobile_number",
        "company_masters.company_name",
    ];

    const headerName = "Role";
    const endpoint = "/getRecords";
    const exportFileName = "RoleData.xlsx";

    return {
        payload,
        navigatePage,
        headerName,
        columnData,
        endpoint,
        searchfields,
        exportFileName,
    };
};

export const exportPageData = {
    modelName: "role_masters",
    schema:schema,
    whereCondition: {
        role_type: { in: [1] },
    },

    // relations: [
    //     {
    //         module: "role_masters",
    //         moduleAs: "createdBy",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "updatedBy",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "subcontractor",
    //     },
    //     {
    //         module: "role_masters",
    //         moduleAs: "role_masters",
    //     },
    //     {
    //         module: "company_masters",
    //         moduleAs: "company_masters",
    //     },
    // ],
    pagination: { page: 1, pageSize: 10000 },
};
